const header = document.querySelector('[data-js-bind="header"]');

if (!header) return;

const toggleMenuButton = header.querySelector('[data-js-bind="toggle-menu"]');
const menu = header.querySelector(`#${toggleMenuButton.getAttribute('aria-controls')}`);
const mainMenu = header.querySelector('[data-js-bind="main-menu"]');
const showMenuOnHoverButtons = [...menu.querySelectorAll('[data-js-bind="show-menu-on-hover"]')];
const toggleSubMenuButtons = [...menu.querySelectorAll('[data-js-bind="toggle-sub-menu"]')];
const subMenus = [...menu.querySelectorAll('[data-js-bind="sub-menu"]')];
const subMenuChilds = [...menu.querySelectorAll('[data-js-bind="sub-menu"] [data-js-bind="sub-menu"]')];

if(!toggleMenuButton || !menu) return;

const MENU_SHOWN_CLASS = 'menu-is-shown';
const ACTIVE_BUTTON_CLASS = 'is-active';
const ACTIVE_SUBMENU_CLASS = 'is-shown';

// Close the sub menu child
const hideSubMenuChildren = () => {
  toggleSubMenuButtons.forEach((subMenuButton) => {
    if (subMenuButton.getAttribute('aria-controls') === "course-groups-submenu") return;
    subMenuButton.classList.remove(ACTIVE_BUTTON_CLASS);
    subMenuButton.setAttribute('aria-expanded', false);
  });
  subMenuChilds.forEach((subMenuChild) => {
    subMenuChild.hidden = true;
  });
};

const toggleMenu = (menuButton) => {
  const expanded =
    menuButton.getAttribute('aria-expanded') === 'true' || false;

  if (!expanded) {
    hideSubMenuChildren();
  };

  document.body.classList[expanded ? 'remove' : 'add'](MENU_SHOWN_CLASS);
  menuButton.setAttribute('aria-expanded', !expanded);
  menu.hidden = !expanded;
};

const toggleMainMenu = () => {
  const expanded =
    toggleMenuButton.getAttribute('aria-expanded') === 'true' || false;
  
  if (!expanded) {
    hideSubMenuChildren();
  };

  toggleMenuButton.setAttribute('aria-expanded', !expanded);
  document.body.classList[expanded ? 'remove' : 'add'](MENU_SHOWN_CLASS);
  menu.hidden = expanded;
}

const showSubMenu = (hoverButton) => {
  const button = hoverButton.querySelector('[data-js-bind="toggle-sub-menu"]');
  const subMenuId = button.getAttribute('aria-controls');

  // Hide all sub menu childs
  hideSubMenuChildren();

  button.setAttribute('aria-expanded', true);
  button.classList.add(ACTIVE_BUTTON_CLASS);
  // Show/hide the submenu controlled by the clicked main menu button
  subMenus.forEach((subMenu) => {
    const clickedSubMenu = subMenu.id === subMenuId;
    // Focus first item in subMenu
    if (clickedSubMenu) {
      subMenu.hidden = false;
    }
  });
}

const closeSubMenu = (hoverButton) => {
  const button = hoverButton.querySelector('[data-js-bind="toggle-sub-menu"]');
  const subMenuId = button.getAttribute('aria-controls');
  
  // Hide all sub menu childs
  hideSubMenuChildren();

  button.setAttribute('aria-expanded', false);
  button.classList.remove(ACTIVE_BUTTON_CLASS);
  // Show/hide the submenu controlled by the clicked main menu button
  subMenus.forEach((subMenu) => {
    const clickedSubMenu = subMenu.id === subMenuId;
    // Focus first item in subMenu
    if (clickedSubMenu) {
      subMenu.hidden = true;
    }
  });
};

const toggleShowSubMenu = (e) => {
  const button = e.target;
  const expanded =
    button.getAttribute('aria-expanded') === 'true' || false;
  const subMenuId = button.getAttribute('aria-controls');
  
  // Hide all sub menu childs
  hideSubMenuChildren();

  button.setAttribute('aria-expanded', !expanded);
  button.classList[expanded ? 'remove' : 'add'](ACTIVE_BUTTON_CLASS);
  // Show/hide the submenu controlled by the clicked main menu button
  subMenus.forEach((subMenu) => {
    const clickedSubMenu = subMenu.id === subMenuId;
    if (!subMenu.contains(e.target)) {
      subMenu.classList.remove(ACTIVE_SUBMENU_CLASS);
    }
    // Focus first item in subMenu
    if (clickedSubMenu) {
      subMenu.hidden = expanded;
      subMenu.classList[expanded ? 'remove' : 'add'](ACTIVE_SUBMENU_CLASS);
    }
  });
};


const hasUserClickedOutsideHeader = (e) => {
  if (!mainMenu.contains(e.target)) {
    toggleSubMenuButtons.forEach((subMenuButton) => {
      subMenuButton.classList.remove(ACTIVE_BUTTON_CLASS);
      subMenuButton.setAttribute('aria-expanded', false);
    });
    subMenus.forEach((subMenu) => {
      subMenu.hidden = true;
    });
  }
}

// Close the select when clicking outside of it
document.addEventListener('click',hasUserClickedOutsideHeader);
toggleMenuButton.addEventListener('click', toggleMainMenu);
toggleSubMenuButtons.forEach(toggleSubMenuButton => toggleSubMenuButton.addEventListener('click', toggleShowSubMenu))
